import { cva } from 'class-variance-authority';

const button = cva(['text-sm font-medium text-gray-500 transition border-0'], {
  variants: {
    disabled: {
      true: 'opacity-50 cursor-not-allowed',
      false: 'hover:text-k-orange',
    },
  },
});

const buttonIcon = cva(['fa'], {
  variants: {
    loading: {
      true: 'animate-spin',
    },
  },
});

export default function NotificationPopoverActionButton({
  icon,
  onClick,
  loading,
}) {
  return (
    <button
      className={button({ disabled: loading })}
      onClick={() => onClick()}
      disabled={loading}
    >
      <i className={[icon, buttonIcon({ loading })].join(' ')} />
    </button>
  );
}
